import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const ModuleSubtopicRAID = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="RAID Levels"
      videos={[
        "https://www.youtube.com/embed/-6sA9nHlZDc"
      ]}
      takeaways={[
        { text: "Learn everything about each RAID level." },
        { text: "Understand the diagrams, advantages, and disadvantages." },
        { text: "Know how each RAID level overcomes the disadvantages of previous levels." }
      ]}
      questions={[]} // No questions provided
      exampleVideos={[]} // No example videos provided
    />
);
}

export default ModuleSubtopicRAID;
